import React from "react";
import { Container, CardBody, Col, Row, Card } from "reactstrap";
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";

export default function TeamSection({ data }) {
    const { tituloSeccion, subtituloSeccion, miembros, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'team';

    if (!miembros || miembros.length === 0) return null;

    return (
        <section className="section overflow-hidden" id={ancla}>
            <Container>
                <Row className="justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-3">{tituloSeccion || 'Our Mind Power'}</h4>
                            {subtituloSeccion && (
                                <p className="para-desc mx-auto text-muted mb-0">{parseHtml(subtituloSeccion)}</p>
                            )}
                        </div>
                    </div>
                </Row>

                <Row>
                    {miembros.map((miembro, key) => (
                        <Col lg={3} md={6} className="mt-4 pt-2" key={key}>
                            <Card className="border-0 text-center shadow border-0 overflow-hidden rounded">
                                <img
                                    src={getPayloadMedia(miembro.foto?.url || miembro.foto?.[0]?.url)}
                                    className="img-fluid"
                                    alt={miembro.nombre}
                                />
                                <CardBody>
                                    <h5 className="mb-1">{miembro.nombre}</h5>
                                    <small className="text-muted">{miembro.cargo}</small>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
